import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { CqFormService } from '../../../../../common/services/CqForm.service';
import { CqFieldService } from '../../../../../common/services/CqField.service';

import * as _ from 'lodash';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'cq-form',
  templateUrl: './cq_form.component.html',
  styleUrls: ['./cq_form.css'],
  providers: [CqFormService, BsModalService, CqFieldService],
})
@Injectable()
export class CqFormComponent implements OnInit {
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();

  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public message: { class: string; content: string } = null;
  public list: any = [];
  public listFields: any = [];
  public listFieldsChecked: any = [];
  public model: any = {};
  public typeModal: string;
  public modalRef: any = {};
  public modalRef2: any = {};
  public types: any = [];
  totalItem: any = 0;
  totalPage: any = 0;
  public modelFilter: any = {};

  public id_delete: number;
  public user: any = {};
  public data_options = [];
  public data_options_copy = [];

  constructor(
    private cqService: CqFormService,
    private FieldService: CqFieldService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {
    this.types = [
      {
        id: 3,
        text: 'IVR',
      },
      {
        id: 1,
        text: 'ACD',
      },
      {
        id: 0,
        text: 'Outbound',
      },
    ];
    this.loadData();
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }

    this.cqService
      .list(request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            this.list = res.data.list;
            this.totalItem = res.data.total;
            const pageString = (this.totalItem / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.status + ' : ' + res.message,
            };
            this.list = [];
            // this.genDataTable();
            this.scrollToTop();
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
          this.list = [];
          // this.genDataTable();
          this.scrollToTop();
        }
      );

    this.FieldService.list({})
      .toPromise()
      .then(res => {
        if (res.status == 200 && res.error == false) {
          this.listFields = res.data.list;
        } else {
          this.listFields = [];
        }
      });
  }

  search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      this.loadData({ name: this.modelFilter.keyword });
    } else {
      this.loadData();
    }
  }

  oncheckboxChanged(data) {
    const check = this.listFieldsChecked.find(value => value._id == data._id);
    console.log(check, data, this.listFields);
    if (check) {
      this.listFieldsChecked = this.listFieldsChecked.filter(value => value._id !== data._id);
      this.data_options = this.listFields.map(value => {
        const obj = {
          name: value.name,
          _id: value._id,
          checked: false,
          isdefault: value.isdefault,
        };
        this.listFieldsChecked.map(item => {
          if (item._id == value._id) {
            obj.checked = true;
          }
        });
        return obj;
      });
    } else {
      this.listFieldsChecked = [...this.listFieldsChecked, data];
      this.data_options = this.listFields.map(value => {
        const obj = {
          name: value.name,
          _id: value._id,
          checked: false,
          isdefault: value.isdefault,
        };
        this.listFieldsChecked.map(item => {
          if (item._id == value._id) {
            obj.checked = true;
          }
        });
        return obj;
      });
    }
    this.data_options_copy = Object.assign([], this.data_options);
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  openModal(template: TemplateRef<any>, id?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-lg',
      keyboard: false,
    };
    this.modalRef = this.modalService.show(template, config);

    this.model = {};
    this.typeModal = id ? 'edit' : 'add';
    if (id) {
      this.cqService
        .find(id)
        .toPromise()
        .then(rs => {
          this.listFieldsChecked = [...rs.data.fields];
          this.model = {
            form_id: rs.data._id,
            name: rs.data.name,
            description: rs.data.description,
          };

          this.data_options = this.listFields.map(value => {
            const obj = {
              name: value.name,
              _id: value._id,
              checked: false,
              isdefault: value.isdefault,
            };
            rs.data.fields.map(item => {
              if (item._id == value._id) {
                obj.checked = true;
              }
            });
            return obj;
          });

          console.log(this.data_options, this.listFieldsChecked, 'data_options');
          this.data_options_copy = Object.assign([], this.data_options);
        });
    } else {
      this.data_options = this.listFields.map(value => {
        const obj = {
          name: value.name,
          _id: value._id,
          checked: false,
          isdefault: value.isdefault,
        };
        return obj;
      });
      this.listFieldsChecked = [];
    }
  }

  add() {
    if (!this.model.name) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên form không được bỏ trống !',
      };
    } else {
      const data = [];
      let check = true;
      if (this.listFieldsChecked.length <= 0) {
        check = false;
        // for (var i = 0; i < this.data_options_copy.length; i++) {
        //     $('#opt-info' + i).css('border-color', '');
        //     if (!this.data_options[i].info || (this.data_options[i].info && this.data_options[i].info.trim() == '')) {
        //         $('#opt-info-' + i).css("border-color", 'red');
        //         check = false;
        //     } else {
        //         data.push(this.data_options[i]);
        //     }
        // }
      }
      if (!check) {
        this.message = {
          class: 'alert dark alert-danger',
          content: 'Trường thông tin không được bỏ trống !',
        };
        setTimeout(() => (this.message = null), 3000);
      } else {
        // this.model.data = _.map(data, e => {
        //     if(e.info && e.info.trim() != '') return e;
        // })
        this.model.fields = this.listFieldsChecked.map(value => value._id);
        this.cqService.create(this.model).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.message = {
                  class: 'alert dark alert-danger',
                  content: 'Thêm mới không thành công',
                };
                this.toastr.error('Thêm mới thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.message = {
                  class: 'alert dark alert-success',
                  content: 'Thêm mới thành công',
                };
                this.toastr.success('Thêm mới thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });

                this.loadData();
                this.modalRef.hide();
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
      }
    }
  }

  edit(data) {
    this.message = null;
    if (!this.model.name) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên form không được bỏ trống !',
      };
    } else {
      const data = [];
      let check = true;
      if (this.listFieldsChecked.length <= 0) {
        check = false;
        // for (var i = 0; i < this.data_options_copy.length; i++) {
        //     $('#opt-info' + i).css('border-color', '');
        //     if (!this.data_options[i].info || (this.data_options[i].info && this.data_options[i].info.trim() == '')) {
        //         $('#opt-info-' + i).css("border-color", 'red');
        //         check = false;
        //     } else {
        //         data.push(this.data_options[i]);
        //     }
        // }
      }
      if (!check) {
        this.message = {
          class: 'alert dark alert-danger',
          content: 'Trường thông tin khóa không được bỏ trống !',
        };
        setTimeout(() => (this.message = null), 3000);
      } else {
        // this.model.data = _.map(data, e => {
        //     if (e.keyword && e.keyword.trim() != '') return e;
        // })
        this.model.data = data;
        const payload = {};
        if (this.model.name) {
          payload['name'] = this.model.name;
        }
        if (this.model.description) {
          payload['description'] = this.model.description;
        }
        if (this.listFieldsChecked) {
          payload['fields'] = this.listFieldsChecked;
        }
        this.cqService.update(this.model.form_id, payload).subscribe(
          res => {
            if (res) {
              const error = res.error;
              if (error) {
                this.message = {
                  class: 'alert dark alert-danger',
                  content: 'Cập nhật không thành công',
                };
                this.toastr.error('Cập nhật thất bại', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              } else {
                this.message = {
                  class: 'alert dark alert-success',
                  content: 'Cập nhật thành công',
                };
                this.toastr.success('Cập nhật thành công', '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
                this.loadData();
                this.modalRef.hide();
              }
            }
          },
          error => {
            this.message = {
              class: 'alert dark alert-danger',
              content: error.message,
            };
          }
        );
      }
    }
    this.scrollToTop();
  }

  public changeType(e: any): void {
    this.model.type = e.value;
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    this.cqService._delete(this.id_delete).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Xóa không thành công',
            };
            this.toastr.error('Xóa không thành công', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Xóa thành công',
            };
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
            // this.modalRef2.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        this.toastr.error('Xóa không thành công', error.message, {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        // this.modalRef2.hide();
      }
    );
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  deleteOption(i) {
    this.data_options_copy.splice(i, 1);
    this.data_options.splice(i, 1);
  }
  addOption() {
    this.data_options_copy.push({ info: '', description: '' });
    this.data_options.push({ info: '', description: '' });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/cq_form/cq_form.component.ts